import styled from 'styled-components';
import PropTypes from 'prop-types';
import { TextColors, Spacings, Fonts } from '../../../styleConstants';

const getStyling = (theme, type) => {
  const styling = {
    filled: {
      Bg: theme.colors.fontGrey,
      Text: theme.colors.white,
      paddingHorizontal: Spacings.SPACING_2B,
      fontSize: Fonts.H7
    },
    hollow: {
      Bg: theme.colors.dropShadowV2,
      Text: theme.colors.fontGreyV2,
      paddingHorizontal: Spacings.SPACING_6,
      fontSize: Fonts.EXTRA_SMALL
    },
    transparent: {
      Bg: theme.colors.white,
      Text: theme.colors.blue,
      paddingHorizontal: Spacings.SPACING_0B,
      fontSize: Fonts.H7
    },
    live: {
      Bg: theme.colors.red,
      Text: theme.colors.whiteV2,
      paddingHorizontal: Spacings.SPACING_2B,
      fontSize: Fonts.H7
    },
    disabled: {
      Bg: theme.colors.white,
      Text: theme.colors.fontLightGrey,
      paddingHorizontal: Spacings.SPACING_0B,
      fontSize: Fonts.EXTRA_SMALL
    },
    discount: {
      Bg: 'rgba(255, 173, 59, 0.12)',
      Text: TextColors.ORANGE,
      paddingHorizontal: Spacings.SPACING_2B,
      fontSize: Fonts.H7
    },
    alert: {
      Bg: theme.colors.white,
      Text: TextColors.RED,
      paddingHorizontal: Spacings.SPACING_0B,
      fontSize: Fonts.H7
    },
    success: {
      Bg: theme.colors.green,
      Text: theme.colors.white,
      paddingHorizontal: '10px',
      fontSize: Fonts.EXTRA_SMALL
    }
  };
  return styling[type];
};

const semiBold = ['filled', 'live', 'alert'];

const Tags = styled.span`
  background-color: ${({ theme, type, bgColor }) => {
    return bgColor || getStyling(theme, type)?.Bg;
  }};
  color: ${({ theme, type }) => getStyling(theme, type)?.Text};
  font-size: ${({ theme, type }) => getStyling(theme, type).fontSize};
  font-weight: ${({ type }) =>
    semiBold.includes(type) ? Fonts.SEMIBOLD : Fonts.BOLD};
  padding: ${({ theme, type }) =>
    `${Spacings.SPACING_6} ${getStyling(theme, type)?.paddingHorizontal}`};
  border-radius: ${Spacings.SPACING_1B};
  display: inline-block;
  text-transform: uppercase;
  line-height: 1;
`;

export default Tags;

Tags.propTypes = {
  type: PropTypes.oneOf([
    'filled',
    'hollow',
    'transparent',
    'live',
    'disabled',
    'discount',
    'alert',
    'success'
  ]),
  bgColor: PropTypes.string
};

Tags.defaultProps = {
  type: 'transparent',
  bgColor: null
};
